<template>
  <div>
    <form id="searchSection" onsubmit="return false;" style="margin-top: 30px;">
      <div class="choice" style="width:100%">
        <input type="text" name="title" class="s-input separate" style="width: 160px" placeholder="专业领域工作委员会名称" v-model="queryInfo.committee_name">
        <input type="text" name="code" class="s-input separate" placeholder="牵头单位" v-model="queryInfo.org_name">
        <input type="text" name="code" class="s-input separate" placeholder="负责人" v-model="queryInfo.manager_name">
        <input type="button" class="s-btn" value="搜索" @click="search">

        <div class="add-btn" @click="showInfoWindow">新建</div>
      </div>
    </form>
    <div id="list">
      <table v-if="this.tableData.length > 0">
        <tbody>
        <tr class="l_header">
          <th class="itemStatus">专业领域工作委员会</th>
          <th class="itemStatus">牵头单位</th>
          <th class="itemStatus">负责人</th>
          <th class="itemStatus">联系方式</th>
          <th class="action" width="180">操作</th>
        </tr>
        <tr class="item" v-for="item in tableData" :key="item.id">
          <td class="itemStatus">{{ item.committee_name }}</td>
          <td class="itemStatus">{{ item.org_name }}</td>
          <td class="itemStatus">{{ item.manager_name }}</td>
          <td class="itemStatus">{{ item.connect }}</td>
          <td class="action">
            <a class="edit" href="javascript:;" @click="querySingle(item.id)">编辑</a>
            <a class="delete" href="javascript:;" @click="askDel(item.id)">删除</a>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="noitems" v-if="tableData.length == 0">没有数据</div>

      <pagination :cur="pageInfo.page" :all="pageInfo.all" :totalData="pageInfo.totalData"
                  :callback="pageCallback"></pagination>
    </div>
    <div class="form_overlay" id="form_overlay" :style="classShowInfoWindow">
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">专业领域工作委员会添加</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label">专业领域工作委员会名称:</span>
              <input type="text" v-model="formInfo.committee_name">
            </div>
            <div class="item">
              <span class="label">牵头单位:</span>
              <input type="text" v-model="formInfo.org_name">
            </div>
            <div class="item">
              <span class="label">负责人:</span>
              <input type="text" v-model="formInfo.manager_name">
            </div>
            <div class="item">
              <span class="label">联系方式:</span>
              <input type="text" v-model="formInfo.connect">
            </div>
          </form>
        </div>
        <div class="form_control">
          <a href="javascript:;" class="button close" id="form_close" @click="hideInfoWindow">取消</a>
          <a href="javascript:;" class="button" id="form_submit" @click="saveInfo">提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../../components/Pagination";

export default {
  name: "AdminOrgCommittee",
  components: {
    Pagination
  },
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        committee_name: '',
        org_name: '',
        manager_name: ''
      },
      formInfo: {
        id: 0,
        committee_name: '',
        org_name: '',
        manager_name: '',
        connect: '',
      },
      tableData: [],
      tableDataCount: 0,
      showWindow: false
    }
  },
  computed: {
    classShowInfoWindow() {
      if (this.showWindow) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    async search() {
      await this.$http.get('/org_committee/', {
        params: this.queryInfo
      }).then((data) => {
        console.log(data)
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    showInfoWindow() {
      this.showWindow = true
    },
    hideInfoWindow() {
      this.showWindow = false
      this.formInfo = {
        id: 0,
        committee_name: '',
        org_name: '',
        manager_name: '',
        connect: '',
      }
    },
    async saveInfo() {
      // if(!this.formInfo.committee_name){
      //   this.$parent.$parent.$parent.showMsg("请输入专业领域工作委员会名称!")
      //   return false
      // }
      // if(!this.formInfo.org_name){
      //   this.$parent.$parent.$parent.showMsg("请输入牵头单位!")
      //   return false
      // }
      // if(!this.formInfo.manager_name){
      //   this.$parent.$parent.$parent.showMsg("请输入负责人!")
      //   return false
      // }
      // if(!this.formInfo.connect){
      //   this.$parent.$parent.$parent.showMsg("请输入联系方式!")
      //   return false
      // }

      if(this.formInfo.id){
        await this.$http.put('/org_committee/' + this.formInfo.id + '/', this.formInfo).then((data) => {
          if (data.id) {
            this.$layer.msg("修改成功！")
            this.hideInfoWindow()
            this.search()
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })
      }else{
        await this.$http.post('/org_committee/', this.formInfo).then((data) => {
          if (data.id) {
            this.$layer.msg("添加成功！")
            this.hideInfoWindow()
            this.search()
          } else {
            this.$layer.msg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('添加失败！')
        })
      }

    },
    async delInfo(id) {
      const url = '/org_committee/' + id + '/'
      await this.$http.delete(url, ).then((data) => {
        console.log(data)
        this.$layer.msg('删除成功！');
        this.search()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('删除失败！');
      })
    },
    askDel(id) {
      this.$parent.$parent.$parent.showConfirm('确定要删除吗？', () => {
        this.delInfo(id)
      });
    },
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    },
    async querySingle(id) {
      const url = '/org_committee/' + id + '/'
      await this.$http.get(url).then((data) => {
        console.log(data)
        this.formInfo = {
          id: id,
          committee_name: data.committee_name,
          org_name: data.org_name,
          manager_name: data.manager_name,
          connect: data.connect,
        }
        this.showInfoWindow()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('数据获取失败！');
      })
    },
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped>
.form_content .label{
  width: 160px;
  text-align: right;
  padding-right: 10px;
}
</style>
